<template>
  <div>
    <b-navbar toggleable="lg" type="dark" variant="light">
      <b-navbar-brand href="#" class="text-dark">
        <strong>Policies</strong>
      </b-navbar-brand>
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav class="ml-auto">
          <b-nav-form>
            <b-form-group
              label-cols-sm="3"
              label-align-sm="right"
              label-size="sm"
              label-for="filterInput"
            >
              <b-input-group size="sm">
                <b-form-input
                  v-model="filter"
                  type="search"
                  id="filterInput"
                  placeholder="Type to Search"
                ></b-form-input>
                <b-input-group-append>
                  <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-nav-form>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <b-table-simple borderless>
      <b-thead>
        <b-tr>
          <b-th>Policy Attestations</b-th>
          <b-th>Requested Date</b-th>
          <b-th>Completed Date</b-th>
          <b-th>Status & Link</b-th>
        </b-tr>
      </b-thead>
      <b-tbody>
        <b-tr>
          <b-td>Code of Conduct Attestation</b-td>
          <b-td>12/12/2019</b-td>
          <b-td></b-td>
          <b-td class="text-danger">OVERDUE</b-td>
        </b-tr>
        <b-tr>
          <b-td>Anti Corruption Policy</b-td>
          <b-td>12/12/2019</b-td>
          <b-td>15/12/2019</b-td>
          <b-td>
            Sent 5 Days Ago
            <br />
            <span class="text-muted">(Due in 2 days)</span>
          </b-td>
        </b-tr>
        <b-tr>
          <b-td>Privacy Policy</b-td>
          <b-td>12/12/2019</b-td>
          <b-td>15/12/2019</b-td>
          <b-td class="text-primary">Completed</b-td>
        </b-tr>
      </b-tbody>
    </b-table-simple>
    <b-row>
      <b-col cols="2">
        <b-form-select v-model="perPage" id="perPageSelect" size="sm" :options="pageOptions"></b-form-select>
      </b-col>
      <b-col>
        <b-pagination
          class="float-right"
          v-model="currentPage"
          :total-rows="rows"
          :per-page="perPage"
          first-text="First"
          prev-text="Prev"
          next-text="Next"
          last-text="Last"
          aria-controls="my-table"
        ></b-pagination>
      </b-col>
    </b-row>
  </div>
</template>
<script>
export default {
  name: "PoliciesComponent",
  data() {
    return {
      filter: null,
      pageOptions: [5, 10, 25, 50, 100],
      perPage: 5,
      currentPage: 1,
      totalRows: 0
    };
  },
  computed: {
    rows() {
      return this.totalRows;
    }
  },
  props: {
    policiesData: Array
  }
};
</script>